export default __webpack_public_path__ + "static/media/partner-icon.a83f47b9.png";